import { render } from "./ThemeButton.vue?vue&type=template&id=0ff4e732&scoped=true"
import script from "./ThemeButton.vue?vue&type=script&lang=js"
export * from "./ThemeButton.vue?vue&type=script&lang=js"

import "./ThemeButton.vue?vue&type=style&index=0&id=0ff4e732&scoped=true&lang=css"

import exportComponent from "/home/jean/lienzo/quinta_amelia_dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff4e732"]])

export default __exports__